<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-tooltip-docs-preview></ui-tooltip-docs-preview></p>
<h1 id="description">Description</h1>
<p>Default button.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
    <span class="hljs-attr">text</span>=<span class="hljs-string">"Click me to see a tooltip!"</span>
    <span class="hljs-attr">uiTooltip</span>=<span class="hljs-string">"This is a lovely tooltip"</span>
    <span class="hljs-attr">uiTooltipPosition</span>=<span class="hljs-string">"bottom"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
    <span class="hljs-attr">text</span>=<span class="hljs-string">"Hover me to see a tooltip!"</span>
    <span class="hljs-attr">uiTooltip</span>=<span class="hljs-string">"This is a lovely tooltip"</span>
    <span class="hljs-attr">uiTooltipTrigger</span>=<span class="hljs-string">"hover"</span>
    <span class="hljs-attr">uiTooltipPosition</span>=<span class="hljs-string">"right"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
    <span class="hljs-attr">text</span>=<span class="hljs-string">"Click me to see a tooltip!"</span>
    <span class="hljs-attr">uiTooltip</span>=<span class="hljs-string">"This is a lovely tooltip"</span>
    <span class="hljs-attr">uiTooltipTrigger</span>=<span class="hljs-string">"click"</span>
    <span class="hljs-attr">uiTooltipDelay</span>=<span class="hljs-string">"1000"</span>
    <span class="hljs-attr">uiTooltipPosition</span>=<span class="hljs-string">"top"</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">uiTooltip</td>
<td align="left">&#64;summary:<br/> Tooltip text</td>
</tr>
<tr>
<td align="left">uiTooltipWidth</td>
<td align="left">&#64;summary:<br/> The width of the tooltip. Defaults to auto.</td>
</tr>
<tr>
<td align="left">uiTooltipMaxWidth</td>
<td align="left">&#64;summary:<br/> The width of the tooltip. Defaults to auto. Value and unit combination is required (e.g 200px)</td>
</tr>
<tr>
<td align="left">uiTooltipHideArrow</td>
<td align="left">&#64;summary:<br/> If the tooltip arrow should be hidden</td>
</tr>
<tr>
<td align="left">uiTooltipPosition</td>
<td align="left">&#64;summary:<br/> The position of the tooltip. top, left, bottom, right. Defaults to bottom</td>
</tr>
<tr>
<td align="left">uiTooltipClass</td>
<td align="left">&#64;summary:<br/> Custom class for the tooltip</td>
</tr>
<tr>
<td align="left">uiTooltipUseTargetWidth</td>
<td align="left">&#64;summary:<br/> If the tooltip should match the host element&#39;s width</td>
</tr>
<tr>
<td align="left">uiTooltipTrigger</td>
<td align="left">&#64;summary:<br/> What should trigger the tooltip to be shown</td>
</tr>
<tr>
<td align="left">uiTooltipDisabled</td>
<td align="left">&#64;summary:<br/> Disables the tooltip triggers</td>
</tr>
<tr>
<td align="left">uiTooltipTriggerHost</td>
<td align="left">&#64;summary:<br/> Set a different trigger rather than the initial host element</td>
</tr>
<tr>
<td align="left">uiTooltipType</td>
<td align="left">&#64;summary:<br/> Set a type/theme</td>
</tr>
<tr>
<td align="left">uiTooltipDelay</td>
<td align="left">&#64;summary:<br/> Set a delay in ms</td>
</tr>
<tr>
<td align="left">uiTooltipInteractive</td>
<td align="left">&#64;summary:<br/> Set if the tooltip should be interactive Useful to have enabled if user should be able to click on links etc. in the tooltip</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
